export default __webpack_public_path__ + "static/media/loading-small.8aee6e49.gif";